import { BaseGraphqlLayer } from '@core/base';
import { DocumentTypes } from '@introspection/documentTypes';
import { ICategoryInputType, IQuery } from '@introspection/index';
import { Injectable } from '@rxdi/core';
import { importQuery } from '@rxdi/graphql-client';
import { map } from 'rxjs/operators';

@Injectable()
export class CategoryService extends BaseGraphqlLayer {
  createCategory(payload: ICategoryInputType[]) {
    return this.mutate({
      mutation: 'create-category.mutation.graphql',
      variables: { payload },
      update: (proxy, res) => {
        const query = importQuery<DocumentTypes>('list-categories.query.graphql');
        const state = proxy.readQuery<IQuery>({ query });

        proxy.writeQuery({
          data: {
            ...state,
            listCategories: [...state.listCategories, ...res.data.createCategory],
          },
          query,
        });
      },
    }).pipe(map((res) => res.data.createCategory));
  }

  deleteCategory(id: string) {
    return this.mutate({
      mutation: 'delete-category.mutation.graphql',
      variables: { id },
    }).pipe(map((res) => res.data.deleteCategory));
  }

  listCategories() {
    return this.query({
      query: 'list-categories.query.graphql',
    }).pipe(map((res) => res.data.listCategories));
  }

  findCategory() {
    return this.query({
      query: 'find-category.query.graphql',
    }).pipe(map((res) => res.data.listCategories));
  }
}
